import { FC } from "react";
import { Divider, Form } from "antd";
import { FormInstance } from "antd/es/form/Form";
import { StaticFilters } from "../StaticFilters";
import { DYNAMIC_FILTERS, STATIC_FILTERS } from "src/Modules/Hotels/constants";
import { Range, ResetButton, DynamicFilters } from "src/components/Filters";
import { SegmentCountType } from "src/constants/filters";

export type FiltersBarContentProps = {
  form: FormInstance;
  initialValues: Record<string, any>;
  handleChange: (changedValues: Record<string, unknown>) => void;
  handleReset: () => void;
  dataCount: SegmentCountType;
  isFetching: boolean;
  dataGroups: any;
  filterComponents: Record<string, { Component: typeof Range }>;
};

const FiltersBarContent: FC<FiltersBarContentProps> = ({
  form,
  initialValues,
  handleChange,
  handleReset,
  dataCount,
  isFetching,
  dataGroups,
  filterComponents,
}) => {
  return (
    <Form className="m-0! p-0!" onValuesChange={handleChange} initialValues={initialValues} form={form} onReset={handleReset}>
      <ResetButton dataCount={dataCount} isFetching={isFetching} />
      <Divider className="m-0.5!" />
      <StaticFilters filters={STATIC_FILTERS} dataGroups={dataGroups} isFetching={isFetching} />
      <DynamicFilters dataGroups={dataGroups} filters={DYNAMIC_FILTERS} filterComponents={filterComponents} isFetching={isFetching} />
    </Form>
  );
};

export default FiltersBarContent;
